/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTournamentTransaction } from './UserTournamentTransaction';
import {
    UserTournamentTransactionFromJSON,
    UserTournamentTransactionFromJSONTyped,
    UserTournamentTransactionToJSON,
    UserTournamentTransactionToJSONTyped,
} from './UserTournamentTransaction';

/**
 * 
 * @export
 * @interface UserTournamentHistoryResponse
 */
export interface UserTournamentHistoryResponse {
    /**
     * 
     * @type {Array<UserTournamentTransaction>}
     * @memberof UserTournamentHistoryResponse
     */
    transactions: Array<UserTournamentTransaction>;
    /**
     * Total matching transactions (across all pages)
     * @type {number}
     * @memberof UserTournamentHistoryResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentHistoryResponse
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentHistoryResponse
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentHistoryResponse
     */
    totalEarnings: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentHistoryResponse
     */
    totalSpent: number;
}

/**
 * Check if a given object implements the UserTournamentHistoryResponse interface.
 */
export function instanceOfUserTournamentHistoryResponse(value: object): value is UserTournamentHistoryResponse {
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('totalEarnings' in value) || value['totalEarnings'] === undefined) return false;
    if (!('totalSpent' in value) || value['totalSpent'] === undefined) return false;
    return true;
}

export function UserTournamentHistoryResponseFromJSON(json: any): UserTournamentHistoryResponse {
    return UserTournamentHistoryResponseFromJSONTyped(json, false);
}

export function UserTournamentHistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentHistoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(UserTournamentTransactionFromJSON)),
        'total': json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'totalEarnings': json['totalEarnings'],
        'totalSpent': json['totalSpent'],
    };
}

export function UserTournamentHistoryResponseToJSON(json: any): UserTournamentHistoryResponse {
    return UserTournamentHistoryResponseToJSONTyped(json, false);
}

export function UserTournamentHistoryResponseToJSONTyped(value?: UserTournamentHistoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': ((value['transactions'] as Array<any>).map(UserTournamentTransactionToJSON)),
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'totalEarnings': value['totalEarnings'],
        'totalSpent': value['totalSpent'],
    };
}

